"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 48 48" },
  React.createElement("path", { d: "M46.075 10.392a18.046 18.046 0 0 1-5.185 1.421 9.053 9.053 0 0 0 3.97-4.994 18.074 18.074 0 0 1-5.732 2.191 9.036 9.036 0 0 0-15.383 8.233A25.628 25.628 0 0 1 5.138 7.811a9.037 9.037 0 0 0 2.794 12.052 8.99 8.99 0 0 1-4.089-1.129v.113a9.033 9.033 0 0 0 7.241 8.853 9.05 9.05 0 0 1-4.077.155 9.036 9.036 0 0 0 8.433 6.269 18.113 18.113 0 0 1-11.211 3.863 18.376 18.376 0 0 1-2.153-.126 25.551 25.551 0 0 0 13.838 4.056c16.6 0 25.684-13.755 25.684-25.684q0-.587-.026-1.168a18.346 18.346 0 0 0 4.503-4.673z" })
);

